import React from "react";
import PropTypes from "prop-types";

export default function LogOut(props) {
  return (
    <svg
      className={props.className}
      width={props.width}
      height={props.height}
      viewBox={`0 0 ${props.width} ${props.height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.2962 0V5.12H9.55546V2.28H15.7406V13.72H9.55546V10.88H7.2962V16H17.9999V0H7.2962Z"
        fill={props.fill}
      />
      <path
        d="M4.02271 4L5.43692 5.41422L3.85114 7H10.0002V9H3.79547L5.43692 10.6414L4.02271 12.0557L0 8.03296L0.00634766 8.02661L0.0012207 8.02148L4.02271 4Z"
        fill={props.fill}
      />
    </svg>
  );
}
LogOut.propTypes = {
  className: PropTypes.string,
  fill: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number
};
LogOut.defaultProps = {
  className: "",
  fill: "#FEFFFF",
  width: 18,
  height: 16
};
